import styled from 'styled-components'
import { rem } from 'polished'
import { themeGet } from 'styled-system'
import theme from 'styles/theme'
import { FormInput } from 'components/Typography'

export const InputText = styled(FormInput).attrs((props) => ({
  disabled: props.isDisabled,
}))`
  border: 1px solid transparent;
  outline: none;
  transition: border 0.3s ease-in-out;
  width: 100%;
  padding: ${theme.space[2]};
  color: ${themeGet('colors.sagedark')};
  border-color: ${theme.colors.sagelight}};

  ${(props) =>
    props.isDisabled &&
    `
    color: ${theme.colors.sagelight}};
    border-color: ${theme.colors.sagelight}};
  `}

  ${(props) =>
    props.hasError &&
    `
    color: ${theme.colors.red}};
    border-color: ${theme.colors.red}};
  `}
`

export const InputQuantity = styled(InputText)`
  &[type='number']::-webkit-outer-spin-button,
  &[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &[type='number'] {
    -moz-appearance: textfield;
  }
  width: 62px;
  height: 60px;
  text-align: center;
  font-size: ${rem(16)};
  margin: 0 ${theme.space[2]};
`

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const QuantityButton = styled.button.attrs((props) => ({
  disabled: props.isDisabled,
  type: 'button',
}))`
  background: none;
  height: 60px;
  margin: 0;
  padding: 0;
  border: none;
  outline: none;
  padding-top: 4px;

  ${(props) =>
    props.isDisabled &&
    `
    svg > path {
      fill: ${theme.colors.sagelight}};
    }
  `}

  ${(props) =>
    props.hasError &&
    `
    svg > path {
      fill: ${theme.colors.red}};
    }
  `}
`

export const Wrapper = styled.div`
  margin: ${theme.space[6]} 0;
`

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: ${theme.space[2]} 0;
  border-bottom: 1px solid ${themeGet('colors.sagelight')};
`

export const LabelWrapper = styled.div`
  ${(props) =>
    props.isDisabled &&
    `
    > div {
      color: ${theme.colors.sagelight}};
    }
  `}

  ${(props) =>
    props.hasError &&
    `
    > div {
      color: ${theme.colors.red}};
    }
  `}
`
